const sizeMap = {
  sm: { width: '60px', height: '60px' },
  md: { width: '80px', height: '80px' },
  lg: { width: '100px', height: '100px' },
};

type Props = {
  size?: keyof typeof sizeMap;
  onClick?: () => void;
  indeterminate?: boolean;
};

export const BigPauseIcon = ({
  size = 'md',
  onClick,
  indeterminate,
}: Props) => {
  const { width, height } = sizeMap[size];

  return (
    <svg
      width={width}
      height={height}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 271.953 271.953"
      xmlSpace="preserve"
      onClick={onClick}
    >
      <defs>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style={{ stopColor: '#0f9f67' }} />
          <stop offset="100%" style={{ stopColor: '#ffffff' }} />
        </linearGradient>
      </defs>
      <g>
        <circle
          cx="135.977"
          cy="135.977"
          r="120"
          stroke="url(#gradient)"
          strokeWidth="15"
          fill="none"
          transform="rotate(-90 135.977 135.977)"
        >
          {/* Keep the existing rotation animation */}
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 135.977 135.977"
            to="360 135.977 135.977"
            dur="2s"
            repeatCount="indefinite"
          />
        </circle>
        {!indeterminate && (
          <>
            <line
              x1="110"
              y1="85"
              x2="110"
              y2="185"
              stroke="#0f9f67"
              strokeWidth="15"
            />
            <line
              x1="155"
              y1="85"
              x2="155"
              y2="185"
              stroke="#0f9f67"
              strokeWidth="15"
            />
          </>
        )}
      </g>
    </svg>
  );
};
